/* ═══════════════════════════════════════════════
   GRAPHIC AVATAR – SHOPIFY THEME JS
   Cart: No drawer. Toast notification on add.
   Header cart icon links directly to /cart.
   ═══════════════════════════════════════════════ */

/* ── TOAST NOTIFICATION ── */
let _toastTimer = null;
function showCartToast(productName, itemCount) {
  const toast = document.getElementById('ga-toast');
  const msg   = document.getElementById('ga-toast-msg');
  if (!toast || !msg) return;
  msg.textContent = productName
    ? `"${productName}" added — ${itemCount} item${itemCount !== 1 ? 's' : ''} in cart`
    : `${itemCount} item${itemCount !== 1 ? 's' : ''} in cart`;
  toast.classList.add('show');
  clearTimeout(_toastTimer);
  _toastTimer = setTimeout(() => toast.classList.remove('show'), 4000);
}

/* ── CART COUNT UPDATE ── */
async function updateCartCount() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    const el   = document.getElementById('cartCount');
    if (el) el.textContent = cart.item_count;
    return cart;
  } catch { return null; }
}

/* ── MOBILE MENU ── */
function toggleMobileMenu() {
  const nav = document.getElementById('mobileNav');
  if (nav) nav.classList.toggle('open');
}

/* ── QTY CONTROL ── */
function changeQty(delta) {
  const input = document.getElementById('qtyInput');
  if (!input) return;
  input.value = Math.max(1, parseInt(input.value || 1) + delta);
}

/* ── ADD TO CART (AJAX) — redirects to /cart page, no drawer ── */
const addToCartForm = document.getElementById('addToCartForm');
if (addToCartForm) {
  addToCartForm.addEventListener('submit', async function(e) {
    e.preventDefault();
    const btn = this.querySelector('.add-to-cart-btn');
    const originalText = btn.innerHTML;
    btn.innerHTML = '⏳ Adding...';
    btn.disabled = true;

    const formData = new FormData(this);
    const productName = this.dataset.productTitle || '';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: formData.get('id'),
          quantity: parseInt(formData.get('quantity') || 1)
        })
      });
      if (res.ok) {
        btn.innerHTML = '✅ Added!';
        const cart = await updateCartCount();
        showCartToast(productName, cart ? cart.item_count : 1);
        setTimeout(() => {
          btn.innerHTML = originalText;
          btn.disabled = false;
        }, 1800);
      } else {
        throw new Error('Failed');
      }
    } catch {
      btn.innerHTML = '❌ Error – try again';
      btn.disabled = false;
      setTimeout(() => { btn.innerHTML = originalText; }, 2000);
    }
  });
}

/* ── STICKY HEADER SHADOW ── */
window.addEventListener('scroll', () => {
  const header = document.getElementById('siteHeader');
  if (!header) return;
  header.style.boxShadow = window.scrollY > 20
    ? '0 4px 24px rgba(108,62,245,0.15)'
    : '0 2px 16px rgba(108,62,245,0.08)';
}, { passive: true });

/* ── SCROLL REVEAL ── */
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity   = '1';
      entry.target.style.transform = 'translateY(0)';
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll(
  '.style-card, .creation-card, .bs-card, .step, .review-card, .trust-item, .showcase-item'
).forEach((el, i) => {
  el.style.opacity   = '0';
  el.style.transform = 'translateY(28px)';
  el.style.transition = `opacity 0.45s ease ${i * 0.06}s, transform 0.45s ease ${i * 0.06}s`;
  revealObserver.observe(el);
});

/* ── CLOSE MOBILE MENU ON OUTSIDE CLICK ── */
document.addEventListener('click', (e) => {
  const nav = document.getElementById('mobileNav');
  const btn = document.querySelector('.mobile-menu-btn');
  if (nav?.classList.contains('open') && !nav.contains(e.target) && !btn?.contains(e.target)) {
    nav.classList.remove('open');
  }
});

/* ═══════════════════════════════════════════════
   DIY & HANDMADE PAGE JS
   ═══════════════════════════════════════════════ */
(function () {
  /* ── FILTER ── */
  const filterBtns = document.querySelectorAll('.diy-filter__btn');
  if (filterBtns.length) {
    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.filter;
        filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        document.querySelectorAll('[data-filter-group]').forEach(el => {
          const groups = el.dataset.filterGroup.split(' ');
          el.style.display = groups.includes(key) ? '' : 'none';
        });
      });
    });
  }

  /* ── WISHLIST TOGGLE ── */
  document.querySelectorAll('.diy-wish-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      const wished = btn.classList.toggle('wished');
      btn.textContent = wished ? '❤️' : '🤍';
    });
  });

  /* ── QUICK ADD TO CART (toast, no drawer) ── */
  document.querySelectorAll('.diy-quick-add').forEach(btn => {
    btn.addEventListener('click', async e => {
      e.stopPropagation();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      const orig = btn.textContent;
      btn.textContent = '⏳ Adding…';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          btn.textContent = '✅ Added!';
          const cart = await updateCartCount();
          showCartToast('', cart ? cart.item_count : 1);
        } else { throw new Error(); }
      } catch {
        btn.textContent = '❌ Error';
      }
      setTimeout(() => { btn.textContent = orig; }, 2000);
    });
  });

  /* ── SCROLL REVEAL (DIY-specific) ── */
  const diyObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('diy-visible'); diyObs.unobserve(e.target); }
    });
  }, { threshold: 0.07 });
  document.querySelectorAll('.diy-reveal').forEach(el => diyObs.observe(el));

  /* ── PRODUCT CARD STAGGER REVEAL ── */
  const cardObs2 = new IntersectionObserver(entries => {
    entries.forEach((e, i) => {
      if (e.isIntersecting) {
        setTimeout(() => { e.target.style.opacity = '1'; e.target.style.transform = 'translateY(0)'; }, i * 70);
        cardObs2.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.diy-product-card').forEach(el => {
    el.style.opacity = '0'; el.style.transform = 'translateY(22px)';
    el.style.transition = 'opacity .45s ease, transform .45s ease';
    cardObs2.observe(el);
  });
})();

/* ═══════════════════════════════════════════════
   INFO PAGES JS — FAQ / Contact
   ═══════════════════════════════════════════════ */
(function () {
  /* ── FAQ ACCORDION ── */
  document.querySelectorAll('.faq-item__q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item   = btn.closest('.faq-item');
      const answer = item.querySelector('.faq-item__a');
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.faq-item__q').forEach(b => {
        b.setAttribute('aria-expanded','false');
        b.closest('.faq-item').querySelector('.faq-item__a').classList.remove('open');
      });
      if (!isOpen) { btn.setAttribute('aria-expanded','true'); answer.classList.add('open'); }
    });
  });

  /* ── FAQ TABS ── */
  document.querySelectorAll('.faq-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.faq-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      const key = tab.dataset.tab;
      document.querySelectorAll('.faq-item').forEach(item => {
        item.style.display = (key === 'all' || item.dataset.tab === key) ? '' : 'none';
      });
      checkNoResults();
    });
  });

  /* ── FAQ SEARCH ── */
  const searchInput = document.getElementById('faqSearch');
  if (searchInput) {
    searchInput.addEventListener('input', () => {
      const q = searchInput.value.toLowerCase().trim();
      document.querySelectorAll('.faq-tab').forEach(t => t.classList.remove('active'));
      document.querySelector('.faq-tab')?.classList.add('active');
      document.querySelectorAll('.faq-item').forEach(item => {
        item.style.display = (!q || item.textContent.toLowerCase().includes(q)) ? '' : 'none';
      });
      checkNoResults();
    });
  }

  function checkNoResults() {
    const noRes = document.getElementById('faqNoResults');
    if (!noRes) return;
    const visible = document.querySelectorAll('.faq-item:not([style*="none"])');
    noRes.style.display = visible.length === 0 ? 'block' : 'none';
  }
})();
